var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clickable delete-button",on:{"click":function($event){return _vm.clickHandler($event)}}},[_c('fa-icon',{attrs:{"icon":"trash-alt"}}),_vm._v(" "+_vm._s(_vm.caption || 'Delete')+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }